import { useState, useEffect, useContext, useRef } from 'react';

import { LiveReserveContext } from '../../../../LiveLessonReseveContext';
import LiveReserveSituationCaseCategory from './category/LiveReserveSituationCaseCategory';

import {
  LiveReserveSituationDisplaySituations, LiveReserveSituationDisplaySituation
} from '../../../../../../../../models/lesson/live/reserve/situation/LiveReserveSituation';
import { LiveReserveSituationType } from '../../../../../../../../models/lesson/live/reserve/situation/type/LiveReserveSituationType';


function LiveReserveSituationCase(props: any) {

  const type: LiveReserveSituationType = props.type;

  const displaySituations: LiveReserveSituationDisplaySituations = useContext(LiveReserveContext).displaySituations;

  // カテゴリ一覧表示(他は閉じる)
  const openCateKey = props.openCateKey;
  const setOpenCateKey = props.setOpenCateKey;
  const cateRefs = props.cateRefs;


  return (
    <div style={{ fontSize: '90%' }}>
      <div
        className="list-group-item"
        style={{
          lineHeight: '25px',
          padding: '10px',
          backgroundColor: '#C3DFC3',
        }}
      >
        <img
          src={type?.icon}
          className="pull-left"
          style={{ height: '25px', marginRight: '10px' }}
          alt={type?.iconAlt}
        />
        <span style={{ color: '#8a6d3b', fontWeight: 'bold' }}>{type?.title}</span>
      </div>

      {/* カテゴリごと */}
      {displaySituations &&
        displaySituations.map((item: LiveReserveSituationDisplaySituation) => (
          <LiveReserveSituationCaseCategory
            key={item.key}
            type={type}
            category={item.key}
            lineList={item.value}
            label={item.label}
            openCateKey={openCateKey}
            setOpenCateKey={setOpenCateKey}
            cateRef={(el: HTMLDivElement | null) => {
              cateRefs.current[item.key] = el;
            }}
          />
        ))
      }

   </div>
  );
}
  
export default LiveReserveSituationCase;